import { Document, Page } from "@react-pdf/renderer";
import { buildPdfBlocks } from "./pdfBlocks.jsx";
import { TEMPLATES, DEFAULT_TEMPLATE } from "./templates/index.js";

// Single source of truth for the PDF.
// Both the on-screen preview (<PDFViewer>) and the downloaded file (pdf().toBlob())
// render this exact component, so what the user sees IS what they download.
export default function ResumeDocument({
  sections = [],
  sectionData = {},
  templateKey = DEFAULT_TEMPLATE,
  authorName,
}) {
  const template = TEMPLATES[templateKey] ?? TEMPLATES[DEFAULT_TEMPLATE];
  const styles = template.styles;
  const blocks = buildPdfBlocks(styles);

  const title = authorName ? `${authorName} — Resume` : "Resume";

  return (
    <Document title={title} author={authorName ?? undefined}>
      <Page size="A4" style={styles.page}>
        {sections.map((s) => {
          const Block = blocks[s.type];
          if (!Block) return null;
          return <Block key={s.id} data={sectionData[s.id]} />;
        })}
      </Page>
    </Document>
  );
}
